import {
  ConverterRule,
  NodeConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { FlowChartNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNode'
import { INode } from 'common/builder/nodes/nodeInterfaces'

import { ContentNodeSmsConverterRule } from './converterRules/ContentNodeSmsConverterRule'

export const SmsNodeConverterRules: Array<
  ConverterRule<INode, FlowChartNode, NodeConverterRulePayload>
> = [ContentNodeSmsConverterRule]
